export default __webpack_public_path__ + "static/ApeSwap-883b4aa3ea0be60d13f4b1ffa43a6c5b.svg";